<template>
  <div class=" is-fullwidth">

    
    
    <h3 class="title is-size-3">Orders With Embroidery Added Between Dates</h3>
    
    <div class="level">
        <div class="level-left">
          <div class="columns " >
              

             <div class=" col pr-2">
                <input type="date" class="input" v-model="start_date" />
                
              </div>
              <div class=" col pr-2" >
                <input type="date" class="input" v-model="end_date" />
                
              </div>

              <div class="col "><input class="input" v-model="search" placeholder="search orders ..."/></div>
              
            </div>
      </div>
        
      </div>

      <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable">
    	<thead>
    		<th width="60">&nbsp;</th>
        <th @click="updateSortOrder('ponumber')" style="cursor:pointer">PO Number
            <span v-if="order_by === 'ponumber DESC'">&#8595;</span>
            <span v-if="order_by === 'ponumber ASC'">&#8593;</span>
          </th>
   	 		<th @click="updateSortOrder('clientname')" style="cursor:pointer">Customer
            <span v-if="order_by === 'clientname DESC'">&#8595;</span>
            <span v-if="order_by === 'clientname ASC'">&#8593;</span>
          </th>
          <th @click="updateSortOrder('garmentname')" style="cursor:pointer">Garment
            <span v-if="order_by === 'garmentname DESC'">&#8595;</span>
            <span v-if="order_by === 'garmentname ASC'">&#8593;</span>
          </th>
          <th>Range</th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Qty</th>
          <th width="130">&nbsp;</th>
          
    	</thead>
    	<tbody>
		    <tr v-if="loading === true">
                <td colspan="9" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && filteredOrders.length == 0">
                <td colspan="9" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
            
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
         <td >
                  <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
              </td>
               <td > <div class="tag is-success" v-if="order.embroidery_approved==1">{{order.ponumber}}</div>
              <span v-if="order.embroidery_approved==0">{{order.ponumber}}</span>
            </td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.range_name}}</td>
          <td>{{order.deliverydate}}</td>
          <td>{{ order.total_qty }}</td>
          <td><button class="button is-small is-link" @click="showEmbroideryModal(order)" >View Details</button></td>
          
              
			</tr>
    	</tbody>
    </table>
    
    <EmbroideryModal :showModal="showModal" @closeModal="showModal=false" :orderID="selectedOrderID" :showAddButtons="showAddButtons" />
    
    <button class="button is-warning" @click="exportXLS()">Export to Excel</button>

    <table id="orderstable-export" style="display:none">
      <thead>
        <tr>
          <th>PO Number</th>
          <th>Customer</th>
          <th>Garment</th>
          <th>Range</th>
          <th>Order Date</th>
          <th>Required</th>
          <th>Qty</th>
          <template v-for="index in 10" >
            <th :key="index + 'trex'">Trex Code {{ index }}</th>
            <th :key="index + 'badge'">Badge</th>
            <th :key="index + 'position'">Position </th>
            <th :key="index + 'stitches'">Stitches </th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr v-for="order in filteredOrders" :key="order.orderID">
          <td>{{ order.ponumber}}</td>
          <td>{{ order.clientname}}</td>
          <td>{{ order.garmentname}}</td>
          <td>{{ order.range_name}}</td>
          <td>{{ order.orderdate_raw}}</td>
          <td>{{ order.deliverydate_raw}}</td>
          <td>{{ order.total_qty}}</td>
          <template v-for="row in order.design_trex_codes" >
            <td :key="'design' + row.id + 'trex'">{{ row.name}}</td>
            <td :key="'design' + row.id + 'badge'"><span v-if="row.badge==1">Yes</span></td>
            <td :key="'design' + row.id + 'position'">{{ row.position}} </td>
            <td :key="'design' + row.id + 'stitches'">{{ row.num_stitches}} </td>
          </template>
          <template v-for="row in order.order_trex_codes" >
            <td :key="'order' + row.id + 'trex'">{{ row.name}}</td>
            <td :key="'order' + row.id + 'badge'"><span v-if="row.badge==1">Yes</span></td>
            <td :key="'order' + row.id + 'position'">{{ row.position}} </td>
            <td :key="'order' + row.id + 'stitches'">{{ row.num_stitches}} </td>
          </template>
          <template v-for="row in order.order_initials" >
            <td :key="'initial' + row.id + 'trex'">{{ row.quantity}} initials</td>
            <td :key="'initial' + row.id + 'badge'"></td>
            <td :key="'initial' + row.id + 'position'">{{ row.position}} </td>
            <td :key="'initial' + row.id + 'stitches'">{{ row.num_stitches}} </td>
          </template>
        </tr>
      </tbody>
    </table>
    
    
  </div>
</template>

<script>
import XLSX from 'xlsx';

import EmbroideryModal from '@/components/Offshore/EmbroideryModal';

import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
    EmbroideryModal
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      ranges: [],
      makeuplocations: [],
      order_by: 'deliverydate ASC',
      makeup_location_id: '',
      showAddButtons: false,
      start_date: this.getStartDate(),
      end_date: '',
      search: ''
    }
  },
   methods: {
      exportXLS() {
      var wb = XLSX.utils.table_to_book(document.getElementById('orderstable-export'), {sheet:"Embroidery Report"});
      XLSX.writeFile(wb, 'embroidery_report.xlsx')

    },
    showEmbroideryModal(order) {
      this.selectedOrderID = order.orderID
     
        this.showModal = true
    },
      async getOrders() {
        this.loading=true
        this.orders = []
        OrderService.getOffshoreEmbroideryOrders(this.accessToken, this.order_by, '', '', '', 1, this.start_date, this.end_date, 1)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
      async setRequired(order)
      {
        order.requires_embroidery = 1
      },
      getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() - 7);
            return d.toISOString().slice(0,10);
             
        },
    
   
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function() { // Rmeoved u from parameters
            //if(  u.in_progress == 0) 
           // {
              return 1
           // }
          })

          if(this.search != '' && this.search != null)
         {
           filteredOrders = filteredOrders.filter(row => 
           row.ponumber.toLowerCase().includes(this.search.toLowerCase())
            || row.clientname.toLowerCase().includes(this.search.toLowerCase())
            || row.garmentname.toLowerCase().includes(this.search.toLowerCase())
            )
         }
          

          return filteredOrders
       
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           
           this.getMakeupLocations();
        });
  },
 
  mounted() {
    if (localStorage.production_allocated_makeup_location_id) {
      this.makeup_location_id = localStorage.production_allocated_makeup_location_id;
    }
    else{
      this.makeup_location_id = 5
    }
      
  },
  watch: {
    makeup_location_id: function () {
      localStorage.production_allocated_makeup_location_id = this.makeup_location_id
      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },
    start_date: function () {
      
      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },
    end_date: function () {
      
      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },
  }
}


</script>

